/*This is a file to load the environment variable and expose to the wb-app*/
const envConfig = {
  analyticsKey: process.env.NEXT_PUBLIC_ANALYTICS_KEY!,
  apiBaseUrl: process.env.NEXT_PUBLIC_API_BASE_URL!,
  appUrls: {
    distUrl: process.env.NEXT_PUBLIC_APP_DIST_URL!,
    publicUrl: process.env.NEXT_PUBLIC_APP_PUBLIC_URL!,
    redirectUrl: process.env.NEXT_PUBLIC_BASE_REDIRECT_URL!
  },
  browserNotificationIcon: `${process.env.NEXT_PUBLIC_APP_PUBLIC_URL}/icons/browser-notification-logo.png`,
  browserNotificationSound: `${process.env.NEXT_PUBLIC_APP_PUBLIC_URL}/sounds/notification-tone.mp3`,
  chainelyUrl: process.env.NEXT_PUBLIC_CHAINELY_URL!,
  envStage: process.env.NEXT_PUBLIC_ENV_STAGE!,
  googleApiKey: process.env.NEXT_PUBLIC_GOOGLE_API_KEY!,
  graphqlUrl: process.env.NEXT_PUBLIC_GRAPHQL_URL!,
  intercomAppId: process.env.NEXT_PUBLIC_INTERCOM_APP_ID!,
  mapboxAccessToken: process.env.NEXT_PUBLIC_MAPBOX_ACCESS_TOKEN!,
  microsoftAuthorityURI: process.env.NEXT_PUBLIC_OUTLOOK_MICROSOFT_AUTHORITY_URI!,
  oauthCallbackUrl: process.env.NEXT_PUBLIC_BASE_OAUTH_CALLBACK_URL!,
  outlookClientId: process.env.NEXT_PUBLIC_OUTLOOK_CLIENT_ID!,
  outlookRedirectUri: process.env.NEXT_PUBLIC_OUTLOOK_REDIRECT_URI!,
  sentryDns: process.env.NEXT_PUBLIC_SENTRY_DNS!,
  serverlessStage: process.env.NEXT_PUBLIC_SERVERLESS_STAGE!,
  stream: {
    appId: process.env.NEXT_PUBLIC_STREAM_APP_ID!,
    appKey: process.env.NEXT_PUBLIC_STREAM_APP_KEY!
  },
  tenorApiKey: process.env.NEXT_PUBLIC_TENOR_API_KEY!,
  typesense: {
    apiKey: process.env.NEXT_PUBLIC_TYPESENSE_API_KEY!,
    appId: process.env.NEXT_PUBLIC_TYPESENSE_APP_ID!,
    postsIndex: process.env.NEXT_PUBLIC_TYPESENSE_POSTS_INDEX!,
    postsSearchApiKey: process.env.NEXT_PUBLIC_TYPESENSE_PUBLIC_POSTS_SEARCH_API_KEY!
  }
} as const

export type TEnvConfig = typeof envConfig
export { envConfig }
